import { axiosIns } from '../../helpers/axios';
import i18n from '../../i18n';

export const state = {
  historyCrupier: [],
};

export const getters = {
  getHistoryCrupier(state) {
    return state.historyCrupier;
  },
  getFields() {
    return [
        {
            key: 'crupier',
            sortable: true,
            label: 'CRUPIER',
            class: 'space-nowrap'
        },
        {
            key: 'serialId',
            sortable: true,
            label: 'SERIAL ID',
            class: 'space-nowrap'
        },
        {
            key: 'roulette',
            sortable: true,
            label: 'RULETA',
            class: 'space-nowrap'
        },
        {
            key: 'providerId',
            sortable: true,
            label: 'PROVIDER ID',
            class: 'space-nowrap'
        },
      {
        key: 'startDate',
        sortable: true,
        label: i18n.t('tableReports.initDate').toUpperCase(),
        class: 'space-nowrap',
      },
      {
        key: 'endDate',
        sortable: true,
        label: i18n.t('tableReports.endDate').toUpperCase(),
        class: 'space-nowrap',
      },
    ];
  },
};

export const mutations = {
  setHistoryCrupier(state, historyCrupier) {
    state.historyCrupier = historyCrupier;
  },
  clearHistoryCrupier(state) {
    state.historyCrupier = [];
  },
};

export const actions = {
  async fetchHistoryCrupier({ commit }, filter) {
    try {
      const { status, data } = await axiosIns.get(
        '/v2/reports/history-crupier',
        {
          params: {
            ...filter,
          },
        }
      );

      if (status !== 200) throw new Error('ERROR GETTING CRUPIERS');

    //   const example = [
    //     {
    //       _id: '688a3ad08ab88d006e5772d4',
    //       crupier: {
    //         name: 'Vanessa Von Lucken',
    //         uuid: '9826f9d8-ace3-4709-8b36-ad3c936bda96',
    //         _id: '683f039bcdfbca006384a59f',
    //         serialId: '4423624',
    //         createdAt: '2025-06-03T14:15:55.318Z',
    //         updatedAt: '2025-06-03T14:15:55.655Z',
    //         __v: 0,
    //       },
    //       endDate: '2025-07-30T15:57:47.679Z',
    //       roulette: {
    //         jackpot: true,
    //         doubleZero: false,
    //         timeOne: 23,
    //         timeTwo: 5,
    //         timeThree: -4,
    //         timeFour: -13,
    //         aditionalTime: -1,
    //         timeToReleaseJack: 0,
    //         timeToStartAnimation: 4,
    //         animation: 0,
    //         _id: '6706c2bf57c316006149b52c',
    //         name: 'Capos',
    //         providerId: '2232323232',
    //         roundDuration: 30,
    //         minutesToDisable: 10,
    //         crupier: '683efdd585f9320063a34b2a',
    //         urlTransmision:
    //           'https://demo.nanocosmos.de/nanoplayer/embed/1.3.3/nanoplayer.html?group.id=e6feb4fe-92d0-43a8-9218-ee8377f7f00f',
    //         createdAt: '2024-10-09T17:51:59.462Z',
    //         updatedAt: '2025-08-01T05:58:39.539Z',
    //         __v: 0,
    //       },
    //       startDate: '2025-07-30T15:31:28.103Z',
    //       createdAt: '2025-07-30T15:31:28.105Z',
    //       updatedAt: '2025-07-30T15:57:47.683Z',
    //       __v: 0,
    //     },
    //   ].map(el => {
    //     const {crupier,roulette,startDate,endDate} = el;

    //     return {
    //         crupier: crupier.name,
    //         serialId: crupier.serialId,
    //         roulette: roulette.name,
    //         providerId: roulette.providerId,
    //         startDate: new Date(startDate).toLocaleString(),
    //         endDate: new Date(endDate).toLocaleString()
    //     }
    //   });

      commit('setHistoryCrupier', data.map(el => {
        const {crupier,roulette,startDate,endDate} = el;

        return {
            crupier: crupier.name,
            serialId: crupier.serialId,
            roulette: roulette.name,
            providerId: roulette.providerId,
            startDate: new Date(startDate).toLocaleString(),
            endDate: new Date(endDate).toLocaleString()
        }
      }));
    } catch (error) {
      console.log('Error fetching history crupier:', error);
      commit('setHistoryCrupier', []);
    }
  },
};
